(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'prop-types', 'react-cursor-position', 'react-required-if', './EnlargedImage', './ImageShape'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'), require('react-cursor-position'), require('react-required-if'), require('./EnlargedImage'), require('./ImageShape'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes, global.reactCursorPosition, global.reactRequiredIf, global.EnlargedImage, global.ImageShape);
        global.ReactImageMagnifyTouch = mod.exports;
    }
})(this, function (exports, _react, _propTypes, _reactCursorPosition, _reactRequiredIf, _EnlargedImage, _ImageShape) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _reactCursorPosition2 = _interopRequireDefault(_reactCursorPosition);

    var _reactRequiredIf2 = _interopRequireDefault(_reactRequiredIf);

    var _EnlargedImage2 = _interopRequireDefault(_EnlargedImage);

    var _ImageShape2 = _interopRequireDefault(_ImageShape);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var ReactImageMagnifyTouch = function (_React$Component) {
        _inherits(ReactImageMagnifyTouch, _React$Component);

        function ReactImageMagnifyTouch(props) {
            _classCallCheck(this, ReactImageMagnifyTouch);

            var _this = _possibleConstructorReturn(this, (ReactImageMagnifyTouch.__proto__ || Object.getPrototypeOf(ReactImageMagnifyTouch)).call(this, props));

            _this.state = {
                smallImageWidth: 0,
                smallImageHeight: 0
            };

            _this.onSmallImageLoad = _this.onSmallImageLoad.bind(_this);
            _this.setSmallImageDimensionState = _this.setSmallImageDimensionState.bind(_this);
            return _this;
        }

        _createClass(ReactImageMagnifyTouch, [{
            key: 'onSmallImageLoad',
            value: function onSmallImageLoad() {
                if (!this.props.smallImage.isFluidWidth) {
                    return;
                }

                this.setSmallImageDimensionState();
            }
        }, {
            key: 'setSmallImageDimensionState',
            value: function setSmallImageDimensionState() {
                var _smallImageEl = this.smallImageEl,
                    smallImageWidth = _smallImageEl.offsetWidth,
                    smallImageHeight = _smallImageEl.offsetHeight;


                this.setState({
                    smallImageWidth: smallImageWidth,
                    smallImageHeight: smallImageHeight
                });
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.props.smallImage.isFluidWidth) {
                    this.setSmallImageDimensionState();
                    window.addEventListener('resize', this.setSmallImageDimensionState);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.props.smallImage.isFluidWidth) {
                    window.removeEventListener('resize', this.setSmallImageDimensionState);
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;

                var _props = this.props,
                    className = _props.className,
                    enlargedImageContainerClassName = _props.enlargedImageContainerClassName,
                    enlargedImageContainerStyle = _props.enlargedImageContainerStyle,
                    enlargedImageClassName = _props.enlargedImageClassName,
                    enlargedImageStyle = _props.enlargedImageStyle,
                    fadeDurationInMs = _props.fadeDurationInMs,
                    isActivatedOnTouch = _props.isActivatedOnTouch,
                    imageClassName = _props.imageClassName,
                    imageStyle = _props.imageStyle,
                    largeImage = _props.largeImage,
                    pressDuration = _props.pressDuration,
                    pressMoveThreshold = _props.pressMoveThreshold,
                    isSmallImageFluidWidth = _props.smallImage.isFluidWidth,
                    style = _props.style,
                    enlargedImagePosition = _props.enlargedImagePosition;


                var fluidWidthSmallImage = Object.assign({}, this.props.smallImage, {
                    width: this.state.smallImageWidth,
                    height: this.state.smallImageHeight
                });
                var fixedWidthSmallImage = this.props.smallImage;
                var smallImage = isSmallImageFluidWidth ? fluidWidthSmallImage : fixedWidthSmallImage;

                var cursorOffset = {
                    x: Math.round(smallImage.width / largeImage.width * smallImage.width / 2),
                    y: Math.round(smallImage.height / largeImage.height * smallImage.height / 2)
                };

                var fluidWidthContainerStyle = {
                    width: 'auto',
                    height: 'auto',
                    fontSize: '0px',
                    position: 'relative'
                };
                var fixedWidthContainerStyle = {
                    width: smallImage.width + 'px',
                    height: smallImage.height + 'px',
                    position: 'relative'
                };
                var priorityContainerStyle = isSmallImageFluidWidth ? fluidWidthContainerStyle : fixedWidthContainerStyle;
                var compositContainerStyle = Object.assign({}, style, priorityContainerStyle);

                var fluidWidthSmallImageStyle = {
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    pointerEvents: 'none'
                };
                var fixedWidthSmallImageStyle = {
                    width: smallImage.width + 'px',
                    height: smallImage.height + 'px',
                    pointerEvents: 'none'
                };
                var prioritySmallImageStyle = isSmallImageFluidWidth ? fluidWidthSmallImageStyle : fixedWidthSmallImageStyle;
                var compositSmallImageStyle = Object.assign({}, imageStyle, prioritySmallImageStyle);

                return _react2.default.createElement(
                    _reactCursorPosition2.default,
                    {
                        className: className,
                        isActivatedOnTouch: isActivatedOnTouch,
                        mapChildProps: function mapChildProps(_ref) {
                            var isActive = _ref.isActive,
                                isPositionOutside = _ref.isPositionOutside,
                                position = _ref.position;
                            return {
                                isHovering: isActive,
                                isPositionOutside: isPositionOutside,
                                position: position
                            };
                        },
                        pressDuration: pressDuration,
                        pressMoveThreshold: pressMoveThreshold,
                        style: compositContainerStyle
                    },
                    _react2.default.createElement('img', {
                        src: smallImage.src,
                        alt: smallImage.alt,
                        className: imageClassName,
                        onLoad: this.onSmallImageLoad,
                        ref: function ref(el) {
                            return _this2.smallImageEl = el;
                        },
                        style: compositSmallImageStyle,
                        srcSet: smallImage.srcSet,
                        sizes: smallImage.sizes
                    }),
                    _react2.default.createElement(_EnlargedImage2.default, {
                        containerClassName: enlargedImageContainerClassName,
                        containerStyle: enlargedImageContainerStyle,
                        cursorOffset: cursorOffset,
                        fadeDurationInMs: fadeDurationInMs,
                        imageClassName: enlargedImageClassName,
                        imageStyle: Object.assign({}, enlargedImageStyle, { pointerEvents: 'none' }),
                        isRenderOnDemand: false,
                        largeImage: largeImage,
                        smallImage: smallImage,
                        imagePosition: enlargedImagePosition
                    })
                );
            }
        }]);

        return ReactImageMagnifyTouch;
    }(_react2.default.Component);

    ReactImageMagnifyTouch.propTypes = {
        className: _propTypes2.default.string,
        enlargedImageContainerClassName: _propTypes2.default.string,
        enlargedImageContainerStyle: _propTypes2.default.object,
        enlargedImageClassName: _propTypes2.default.string,
        enlargedImageStyle: _propTypes2.default.object,
        fadeDurationInMs: _propTypes2.default.number,
        isActivatedOnTouch: _propTypes2.default.bool,
        imageClassName: _propTypes2.default.string,
        imageStyle: _propTypes2.default.object,
        largeImage: _ImageShape2.default,
        pressDuration: _propTypes2.default.number,
        pressMoveThreshold: _propTypes2.default.number,
        smallImage: _propTypes2.default.shape({
            alt: _propTypes2.default.string,
            isFluidWidth: _propTypes2.default.bool,
            src: _propTypes2.default.string.isRequired,
            srcSet: _propTypes2.default.string,
            sizes: _propTypes2.default.string,
            width: (0, _reactRequiredIf2.default)(_propTypes2.default.number, function (props) {
                return !props.isFluidWidth;
            }),
            height: (0, _reactRequiredIf2.default)(_propTypes2.default.number, function (props) {
                return !props.isFluidWidth;
            })
        }),
        style: _propTypes2.default.object,
        enlargedImagePosition: _propTypes2.default.oneOf(['beside', 'over'])
    };
    ReactImageMagnifyTouch.defaultProps = {
        fadeDurationInMs: 500,
        enlargedImagePosition: 'over'
    };
    exports.default = ReactImageMagnifyTouch;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-image-magnify/dist/ReactImageMagnifyTouch.js
 ** module id = 1105
 ** module chunks = 0
 **/